<app-dialog
  #dialog
  [key]="'onboarding-select-company'"
  [action]="'onboarding-select-company'"
  [headerTheme]="'simple'"
  [title]="'Selecionar empresa para o Onboarding'"
  [appendTo]="'body'"
  [maxWidth]="'440px'">
  <div class="p-4">
    <app-select
      [label]="'Empresa'"
      [options]="companyOptions"
      [loading]="isLoading"
      [placeholder]="'Selecione uma empresa'"
      [(ngModel)]="selectedCompanyId">
    </app-select>
  </div>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [label]="'Confirmar'"
        [disabled]="!isFormValid() || isLoading"
        (sendButtonClick)="confirm()">
      </app-button>
    </div>
  </ng-template>
</app-dialog>
